import React from 'react';

export default function Layout(props) {
  return <div>{props.children}</div>;
}
